import RMModal from "@rmlibrary/modal";

let termRates;

function init() {
    return new Promise(function (resolve) {
        let lang = document.documentElement.lang.toLowerCase().indexOf("fr") >= 0 ? "fr" : "en";
        $.get("../common/data/termRates.json", function (data) {
            termRates = data.rates.map(function (e, i) {
                e.id = i;
                return e;
            });
            // console.log(termRates, "---termRates1");
            $("#fixed-rate-year")
                .empty()
                .each(function (i, e) {
                    termRates.forEach(function (rateObject) {
                        if (rateObject.id < 10) {
                            $(e).append("<option value='" + rateObject.id + "'>" + rateObject[lang] + "</option>");
                        }
                    });
                });

            $("#variable-rate-year")
                .empty()
                .each(function (i, e) {
                    termRates.forEach(function (rateObject) {
                        if (rateObject.id > 9) {
                            $(e).append("<option value='" + rateObject.id + "'>" + rateObject[lang] + "</option>");
                        }
                        // $(e).append("<option value='" + rateObject.id + "'>" + rateObject.PRODUCT + "</option>");
                    });
                });

            //variable mortgage products
            $.get("https://dmtsms.scotiabank.com/api/rates/daily/varmortgage", function (data) {
                if (data) {
                    applyVarMortgageRates(data);
                }
                getStdMortRates();
            }).fail(function () {
                openErrorModal();
                getStdMortRates();
            });
            function applyVarMortgageRates(data) {
                termRates.forEach(function (e) {
                    // console.log(e.serverMap);
                    data.data.forEach(function (i) {
                        if (i.PRODUCT == e.serverMap) {
                            e.value = i.RATE;
                        }
                    });
                });
            }
            function applyStdMortgageRates(data) {
                var _suffix = "C";
                if (data.PRODUCT == "OPEN") {
                    _suffix = "O";
                } else if (data.PRODUCT == "FLEXIBLE") {
                    _suffix = "F";
                }
                termRates.forEach(function (e) {
                    // console.log(e.serverMap);
                    data.TERMS.forEach(function (i) {
                        if (i.TERM_VALUE + _suffix == e.serverMap) {
                            e.value = i.RATE;
                        }
                    });
                });
            }
            function getStdMortRates() {
                //fixed rate open/closed product
                $.get("https://dmtsms.scotiabank.com/api/rates/daily/nonspecialmortgage", function (data) {
                    if (data) {
                        applyStdMortgageRates(data.data[1]);
                        applyStdMortgageRates(data.data[5]);
                        applyStdMortgageRates(data.data[6]);
                    }
                    resolve(1);
                }).fail(function () {
                    openErrorModal();
                    resolve(1);
                });
            }
            function openErrorModal() {
                const $errorEl = $("#error-modal");
                if ($errorEl.hasClass("hidden")) {
                    let errorModal = RMModal.get($errorEl[0], {
                        closeOnBackdropClick: false,
                        closeOnEscape: false,
                        preventBackgroundScroll: true
                    });
                    errorModal.open();
                    $errorEl.removeClass("hidden");
                }
            }
        });
    });
}
//
function getByID(id) {
    id = parseInt(id);
    return termRates.filter(function (e) {
        return e.id === id;
    })[0];
}
//
function getAllRates() {
    return termRates;
}

//
export { init, getByID, getAllRates };
